<div class="loading-overlay" *ngIf="isLoading">
    <div class="loader-content">
        <mat-icon class="loader-icon">{{ loaderIcon }}</mat-icon>
        <p class="loader-text">{{ loaderText }}</p>
    </div>
  </div>
  